(() => {
  if (window.__tmEditorialLinkTrackingBound) return;
  window.__tmEditorialLinkTrackingBound = true;
  const storageKey = 'tmEditorialPendingNavigationV1';
  const allowed = () => window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
  const cleanUrl = url => url.origin + url.pathname;
  const emit = (name, parameters) => {
    if (!allowed() || typeof window.gtag !== 'function') return false;
    window.gtag('event', name, {...parameters, send_to: 'G-S62SLLKZV8', transport_type: 'beacon'});
    return true;
  };
  // Carry one consented navigation event into the destination tab so unloading
  // the article cannot cancel the Google tag's queued network request.
  let tries = 0;
  function flush() {
    let pending;
    try { pending = JSON.parse(sessionStorage.getItem(storageKey) || 'null'); } catch (_) { return; }
    if (!pending) return;
    const target = cleanUrl(new URL(pending.parameters?.destination_url || location.href));
    if (Date.now() - pending.at > 60000 || target !== cleanUrl(location)) {
      try { sessionStorage.removeItem(storageKey); } catch (_) {}
      return;
    }
    if (allowed() && typeof window.gtag === 'function') {
      // Consume once. No automatic resend that could inflate event counts.
      try { sessionStorage.removeItem(storageKey); emit(pending.name, pending.parameters); } catch (_) {}
    } else if (++tries < 100) setTimeout(flush, 100);
    else { try { sessionStorage.removeItem(storageKey); } catch (_) {} }
  }
  flush();
  document.addEventListener('click', event => {
    const link = event.target.closest('a[href]');
    if (!link || !allowed()) return;
    const taggedProduct = link.matches('[data-tm-editorial-product-link]');
    const taggedGuide = link.matches('[data-tm-product-guide-link]');
    const articleLink = location.pathname.includes('/blogs/') && link.closest('.article-template__content');
    if (!taggedProduct && !taggedGuide && !articleLink) return;
    const destination = new URL(link.href, location.href);
    if (destination.origin !== location.origin || !/\/(products|pages|blogs)\//.test(destination.pathname)) return;
    const name = taggedProduct ? 'editorial_product_click' : taggedGuide ? 'product_guide_click' : 'editorial_navigation_click';
    const parameters = {
      article_url: location.pathname.includes('/blogs/') ? cleanUrl(location) : '',
      destination_url: cleanUrl(destination),
      article_handle: link.dataset.articleHandle || location.pathname.split('/').pop(),
      product_handle: link.dataset.productHandle || (destination.pathname.includes('/products/') ? destination.pathname.split('/').pop() : ''),
      link_url: cleanUrl(destination), page_location: cleanUrl(location),
      destination_type: destination.pathname.includes('/products/') ? 'product' : destination.pathname.includes('/blogs/') ? 'article' : 'guide'
    };
    const sameTab = !event.defaultPrevented && event.button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey && (!link.target || link.target === '_self') && !link.hasAttribute('download') && destination.pathname !== location.pathname;
    if (sameTab) {
      try { sessionStorage.setItem(storageKey, JSON.stringify({at: Date.now(), name, parameters})); return; } catch (_) {}
    }
    try { emit(name, parameters); } catch (_) {}
  });
})();
